import { createAsyncThunk } from "@reduxjs/toolkit";

export const fetchTutorialXpaths = createAsyncThunk("tutorial/fetchTutorialXpaths", async ({ currentPage }, { rejectWithValue, extra }) => {
	try {
		const { data } = await extra.apiUserAdv.getTutorialXpaths({ currentPage: String(currentPage).toLowerCase() });
		return data;
	} catch (e) {
		return rejectWithValue(e);
	}
});
